import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-c9c648ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "alphabet-filter-container" };
const _hoisted_2 = { class: "alphabet-filter" };
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.selectLetter(''))),
                class: _normalizeClass([{ active: !_ctx.selectedLetter }, "alphabet-button all-button"])
            }, " Todos ", 2 /* CLASS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alphabet, (letter) => {
                return (_openBlock(), _createElementBlock("button", {
                    key: letter,
                    onClick: ($event) => (_ctx.selectLetter(letter)),
                    class: _normalizeClass([{ active: _ctx.selectedLetter === letter }, "alphabet-button"])
                }, _toDisplayString(letter), 11 /* TEXT, CLASS, PROPS */, _hoisted_3));
            }), 128 /* KEYED_FRAGMENT */))
        ])
    ]));
}
